// extracted by mini-css-extract-plugin
module.exports = {"page-header__actions":"style_page-header__actions__3zBos"};